import { render, staticRenderFns } from "./VehicleRequestBrandModelCount.vue?vue&type=template&id=29175aa6&"
import script from "./VehicleRequestBrandModelCount.vue?vue&type=script&lang=js&"
export * from "./VehicleRequestBrandModelCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports